import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ListingService } from '../../../services/listing.service';
import { NotificationService } from '../../../services/notification.service';
import { EditformComponent } from '../../../shared/components/editform/editform.component';
import { ViewService } from '../../../services/view.service';
import { RecordService } from '../../../services/record.service';
import { DialogService } from '../../../services/dialog.service';
import { LinkRelatedRecordComponent } from '../../../shared/components/widget/dialog/link-related-record/link-related-record.component';
import { LooseObject } from '../../../objects/loose-object';
import { filter, finalize, first } from 'rxjs/operators';
import { filled } from '../../../shared/utils/common';
import { get } from 'lodash-es';

@Component({
  selector: 'app-contract-sites',
  templateUrl: './contract-sites.component.html',
  styleUrls: ['./contract-sites.component.scss'],
  providers: [ ListingService ],
})

export class ContractSitesComponent implements OnInit {

  @Input() strRecordId : string;
  @Input() strModule : string;

  arContractSites: LooseObject[] = [];

  public strFirstValue = '';
  public arPreviousPages = {};
  public bLoading = false;
  public totalRecords = 0;
  public bPageLoaded: boolean = false;

  constructor(
    public listingService: ListingService,
    private notificationService: NotificationService,
    private viewService: ViewService,
    private recordService: RecordService,
    private dialog: MatDialog,
    private dialogService: DialogService,
  ) {}

  ngOnInit() {
    this.fetchList('default');
  }

  fetchList(page: string = '') {

    this.arContractSites = [];
    this.bLoading = true;

    const objPagination = this.listingService.beforeFetching(page);
    this.listingService.fetchData(
      JSON.stringify(objPagination['objPage']),
      'contract_sites',
      JSON.stringify({
        contract_id: this.strRecordId
      })
    ).pipe(
      finalize(() => this.bLoading = false)
    ).subscribe(response => {
      this.arContractSites = response['data'];
      this.totalRecords = response['total_records'];
      this.listingService.afterFetching(response, page);
      this.bLoading = false;
      this.bPageLoaded = true;
    });
  }

  /**
   * open site form
   *
   * @param id
   */
  openSiteForm(id: string = '') {
    let objSiteDialog = this.dialog.open(EditformComponent, this.recordService.compilePopUpConfig({
      arData: {
        module : this.strModule
      },
      strModule: 'sites',
      strId: id,
      strMode: (id) ? 'edit' : 'add'
    }));

    objSiteDialog.afterClosed().pipe(
      first(),
    ).subscribe( response => {
      if (response !== undefined && response.status == 'save') {
        setTimeout(() => this.fetchList('default'), response.data === 'record_update_success' ? 0 : 3500);
      }
    });
  }

  /**
   * unlink record
   *
   * @param id
   */
  unlinkRecord(id: string) {
    this.notificationService.sendConfirmation('unlink_site_confirmation')
      .pipe(
        filter(confirmation => confirmation.answer == true)
      ).subscribe( () =>
        this.recordService.deleteRecord('contract_sites', id).subscribe( response => {
          this.notificationService.notifySuccess('record_unlink_success')
          this.fetchList('default');
        })
      );
  }

  /**
   * open multiple link
   */
  linkSites(): void {
    let objLinkRecord = this.dialog.open(LinkRelatedRecordComponent, this.recordService.compilePopUpConfig({
      record_id: this.strRecordId,
      record_module: 'contracts',
      list_module: 'sites',
      target_module: 'contract_sites',
    }));

    objLinkRecord
      .afterClosed()
      .pipe(
        filter( response => filled(response) )
      )
      .subscribe(() => setTimeout(() => this.fetchList() , 2000) )
  }

  recordDialog() {
    let objRecordDialog = this.dialog.open(EditformComponent, this.recordService.compilePopUpConfig({
      arData: {
        module : this.strModule,
        contract_id: this.strRecordId,
        customer_id: get(this.viewService.objRecord, 'record_details.customer_id'),
        customer_text: get(this.viewService.objRecord, 'record_details.customer_text'),
      },
      strModule: 'sites',
      strMode: 'add'
    }));

    objRecordDialog.afterClosed().pipe(
      first(),
    ).subscribe(editRecordData => {
      if (filled(editRecordData) && editRecordData.status == 'save') {

        let strSiteId = get(editRecordData, 'data.id');
        if (filled(strSiteId)) {

          this.notificationService.sendConfirmation('link_site_confirmation').pipe(
          ).subscribe( (response) => {
            if (response.answer === true) {

              this.recordService.linkRecord('contract_sites', [
                {
                  contract_id: this.strRecordId,
                  site_id: strSiteId,
                }
              ]).subscribe( response => {
                this.notificationService.notifySuccess( response.status == 200
                  ? 'link_record_successfully'
                  : 'content_report_error'
                );
                setTimeout(() =>
                  this.fetchList() , response.status == 200 ? 3500 : 0
                )
              })
            } else {
              setTimeout(() =>
                this.fetchList() , editRecordData.data === 'record_update_success' ? 0 : 3500
              )
            }
          });
        }
      }
    });
  }
}